import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "id": "introduction",
  "title": "Introduction"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The UI Framework is the set of components within Episerver's Design System. There is a `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@episerver/ui-framework"
      }}>{`package on npm`}</a>{` with a React implementation that can be used by anyone. The Interactive Demo's at the top of the component descriptions are using it.`}</p>
    <p>{`The components exist in three phases and is noted in the component title:`}</p>
    <ul>
      <li parentName="ul">{`Alpha: Guidelines for how the component can be used, including wireframes.`}<ul parentName="li">
          <li parentName="ul">{`They lack an implementation in React that can be used right away.`}</li>
        </ul></li>
      <li parentName="ul">{`Beta: The guidelines have gone through some more research, and there is some React implementation available.`}<ul parentName="li">
          <li parentName="ul">{`The implementation is not used in any products, and can be buggy or behave differently compared to the guidelines.`}</li>
        </ul></li>
      <li parentName="ul">{`No labeling: The guidelines are backed up by components used in some products and what is known to not work has been addressed.`}<ul parentName="li">
          <li parentName="ul">{`Nothing is ever truly complete and is always subject to change given new information.`}</li>
        </ul></li>
    </ul>
    <p>{`There is an extra stage that components go through that is visible on the Interactive Demo and the public Readme of the npm package:`}</p>
    <ul>
      <li parentName="ul">{`Preview: As components are contributed from other teams, and has worked for them, they might not follow the same API design, or otherwise look and behave like, other components in the UI Framework. They are usable but subject to major changes.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      